
























































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { AppModule } from '@/store/modules/app';
import WorkerBookingOfferApplyDecline from '@/components/AnonWorkers/WorkerBookingOfferApplyDecline.vue';
import { VuetifyConfirmObject } from "vuetify-confirm";
import UpdateAnonWorkerBookingOfferRequest from '@/models/AnonBookingRoleWorkers/UpdateAnonWorkerBookingOfferRequest';
import AnonBookingRoleWorkerDto from '@/models/AnonBookingRoleWorkers/AnonBookingRoleWorkerDto';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue';

@Component({
  name: 'BookingOffer',
  components: { WorkerBookingOfferApplyDecline, BookingRoleWorkerShiftStatus }
})
export default class BookingOffer extends GiganautVue {

  get bookingOffer(): AnonBookingRoleWorkerDto {
    return WorkerAnonModule.bookingOffer;
  }

  get loading() {
    return WorkerAnonModule.loading;
  }

  get isOfferSubmitted() {
      return WorkerAnonModule.isBookingOfferSubmitted;
  }
}
